module.exports = __webpack_public_path__ + "static/media/interior-design.4f915216.jpg";